import { render, staticRenderFns } from "./ProjectExpenseSavingsPage.vue?vue&type=template&id=7b7f87ab&scoped=true"
import script from "./ProjectExpenseSavingsPage.vue?vue&type=script&lang=ts"
export * from "./ProjectExpenseSavingsPage.vue?vue&type=script&lang=ts"
import style0 from "./ProjectExpenseSavingsPage.vue?vue&type=style&index=0&id=7b7f87ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7f87ab",
  null
  
)

export default component.exports